module.exports = __webpack_public_path__ + "img/keepwatch.5ba71f5b.png";